import { sumBy } from 'lodash/fp';
import { OrderItem } from '@mews-commander/types';
import { OrderItemType } from '@mews-commander/data-access';
import { AdditionalOrderItemType } from './types';

export const additionalItemTypes: AdditionalOrderItemType[] = [
    OrderItemType.AdditionalExpenseRebate,
    OrderItemType.CancellationFee,
    OrderItemType.CityTax,
    OrderItemType.CityTaxDiscount,
    OrderItemType.CustomItem,
    OrderItemType.Deposit,
    OrderItemType.ExchangeRateDifference,
    OrderItemType.NightRebate,
    OrderItemType.ProductOrderRebate,
    OrderItemType.ServiceCharge,
    OrderItemType.Surcharge,
    OrderItemType.MulticurrencyFee,
    OrderItemType.AllowanceDiscount,
    OrderItemType.AllowanceBreakage,
    OrderItemType.AllowanceContraBreakage,
];

export const calculateOrderItemsCount = sumBy<OrderItem>(
    ({ unitMultiplier, timeMultiplier, personMultiplier }) => unitMultiplier * personMultiplier * timeMultiplier
);
